(function () {
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  function initSlider(slider) {
    var track = slider.querySelector('[data-slider-track]');
    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if (!track) return;
    var amount = function () { return Math.max(240, Math.round(track.clientWidth * 0.8)); };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
  }

  function switchGalleryImage(gallery, mediaId) {
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var mainItems = gallery.querySelectorAll('[data-gallery-main-item]');
    var matched = false;
    mainItems.forEach(function (item) {
      var isMatch = item.getAttribute('data-gallery-main-item') === mediaId;
      if (isMatch) matched = true;
      item.hidden = !isMatch;
      item.classList.toggle('is-active', isMatch);
    });
    if (!matched) return;
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-gallery-thumb') === mediaId);
    });
  }

  if (window.customElements && !window.customElements.get('product-recommendations')) {
    window.customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        var url = this.getAttribute('data-url');
        if (!url) return;
        var el = this;
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var wrapper = document.createElement('div');
            wrapper.innerHTML = text;
            var content = wrapper.querySelector('product-recommendations');
            if (content && content.innerHTML.trim().length) {
              el.innerHTML = content.innerHTML;
              var slider = el.querySelector('[data-slider]');
              if (slider) initSlider(slider);
            } else {
              var section = el.closest('.related-products-wrap');
              if (section) section.hidden = true;
            }
          })
          .catch(function () {});
      }
    });
  }

  ready(function () {
    var toggle = document.querySelector('[data-nav-toggle]');
    var panel = document.querySelector('[data-nav-panel]');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        toggle.classList.toggle('is-open', !open);
        panel.classList.toggle('is-open', !open);
      });
    }

    document.querySelectorAll('[data-slider]').forEach(initSlider);

    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          switchGalleryImage(gallery, thumb.getAttribute('data-gallery-thumb'));
        });
      });
    });

    document.querySelectorAll('[data-quantity]').forEach(function (quantity) {
      var input = quantity.querySelector('input');
      quantity.querySelectorAll('button').forEach(function (button) {
        button.addEventListener('click', function () {
          var current = parseInt(input.value || '1', 10);
          if (button.name === 'minus') input.value = Math.max(parseInt(input.min || '1', 10), current - 1);
          if (button.name === 'plus') input.value = current + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var jsonEl = form.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var idInput = form.querySelector('[data-selected-variant-id]');
      var optionSelects = form.querySelectorAll('[data-option-select]');
      var submit = form.querySelector('[name="add"]');
      var stockEl = form.querySelector('[data-stock-message]');
      var gallery = document.querySelector('[data-gallery]');
      function updateVariant() {
        var selected = Array.prototype.map.call(optionSelects, function (select) { return select.value; });
        var variant = product.variants.find(function (candidate) {
          return candidate.options.every(function (option, index) { return option === selected[index]; });
        });
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? submit.getAttribute('data-add-text') : submit.getAttribute('data-sold-text');
        }
        if (stockEl) {
          var threshold = parseInt(stockEl.getAttribute('data-threshold') || '0', 10);
          var lowStock = variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold;
          if (lowStock) {
            var template = stockEl.getAttribute('data-low-stock-template') || '';
            stockEl.textContent = template.replace('__COUNT__', variant.inventory_quantity);
            stockEl.hidden = false;
          } else {
            stockEl.hidden = true;
          }
        }
        if (gallery && variant.featured_image) {
          switchGalleryImage(gallery, String(variant.featured_image.id));
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      optionSelects.forEach(function (select) { select.addEventListener('change', updateVariant); });
    });

    document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
      var triggers = tabs.querySelectorAll('[data-tab-trigger]');
      var panels = tabs.querySelectorAll('[data-tab-panel]');
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var target = trigger.getAttribute('data-tab-trigger');
          triggers.forEach(function (t) {
            t.classList.toggle('is-active', t === trigger);
            t.setAttribute('aria-selected', t === trigger ? 'true' : 'false');
          });
          panels.forEach(function (thisPanel) {
            thisPanel.hidden = thisPanel.getAttribute('data-tab-panel') !== target;
          });
        });
      });
    });

    document.querySelectorAll('[data-countdown]').forEach(function (block) {
      var target = new Date(block.getAttribute('data-end'));
      var timerEl = block.querySelector('[data-countdown-timer]');
      if (!timerEl || isNaN(target.getTime())) { block.hidden = true; return; }
      var interval;
      function tick() {
        var diff = target.getTime() - Date.now();
        if (diff <= 0) {
          block.hidden = true;
          if (interval) clearInterval(interval);
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        timerEl.textContent = days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's';
      }
      tick();
      interval = setInterval(tick, 1000);
    });

    document.querySelectorAll('[data-popup-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        var dialog = document.getElementById(button.getAttribute('data-popup-open'));
        if (dialog && dialog.showModal) dialog.showModal();
      });
    });
    document.querySelectorAll('[data-popup-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        var dialog = button.closest('dialog');
        if (dialog) dialog.close();
      });
    });

    document.querySelectorAll('[data-buy-now]').forEach(function (button) {
      button.addEventListener('click', function () {
        var form = button.closest('form');
        if (!form) return;
        var idInput = form.querySelector('[data-selected-variant-id]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var id = idInput ? idInput.value : '';
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        if (!id) return;
        window.location.href = '/cart/' + id + ':' + qty;
      });
    });
  });
}());
